import React from 'react';

import styles from './styles/styles.module.scss';

export default function Tag({ title, className }) {
  if (!title) {
    return null;
  }
  const classes = [styles.tag];
  if (className) {
    classes.push(className);
  }
  return (
    <span title={title} className={classes.join(' ')}>
      {title}
    </span>
  );
}
